import { ProductDetails, useGetProductById } from "modules/products";
import { useParams } from "react-router-dom";

const EditProductPage = () => {
  const { editableProductId } = useParams();

  const { product: editableProduct, isLoading: isEditableProductLoading } =
    useGetProductById(editableProductId as string, { cacheTime: 0 });

  return (
    <ProductDetails
      editableProduct={editableProduct}
      isEditableProductLoading={isEditableProductLoading}
    />
  );
};

export default EditProductPage;
